import type { IDrawRequest } from 'pages/Borrower'

/**
 * `Num` from the utils barrel does this, but importing the barrel here drags the whole app graph
 * in and the reducers cycle under jest, which is why the budget's other testable helper imports
 * nothing either. An amount can arrive typed with separators, hence the strip.
 */
const num = (value: unknown) => {
  const parsed = Number(String(value ?? '').replace(/,/g, ''))
  return isNaN(parsed) ? 0 : parsed
}

/**
 * What one draw request asked for against a single budget line.
 *
 * A request carries its figures in one of two shapes. One raised in the borrower portal spreads
 * its money across the lines it names, so every amount and narrative sits on the line entry and
 * the request-level `amount` is left at 0 with `description` at ''. One that arrived through the
 * fund-draw-request webhook has no line entries to speak of and carries a single amount and
 * narrative at the request level instead.
 *
 * So the line entry wins where there is one, and the request level is the fallback. Reading only
 * the request level - which the budget cell's popup used to do - prints $0.00 and no description
 * for every portal request, which is the common case.
 */
export const drawRequestForLine = (request: IDrawRequest, lineValue: string, lineKey: string) => {
  const line = (request.types || []).find((type) => type.value === lineValue && type.key === lineKey)
  const amount = num(line?.amount)
  return {
    amount: amount || num(request.amount),
    description: line?.desc || request.description || '',
  }
}
